////////LIBRARY/////////
import { find, isUndefined } from 'lodash'
///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	toastSuccessActionCreators,
	initKioskCreationDefinitionActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getAvailableListsCustomer = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getAvailableListsCustomerSuccess(data.data))
		// Checking if there is only one kiosk model
		// In this case, we trigger the call to get profiles
		if (data.data.kioskModels.length === 1 && data.data.kioskModels[0].selected) {
			const apiCallProfiles = R.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK(data.data.kioskModels[0].id)
			try {
				const dataProfiles = yield API_TOKEN(user.jwt).get(apiCallProfiles)

				yield put(initKioskCreationDefinitionActionCreators.getProfilesByKioskCustomerSuccess(dataProfiles.data))

				// And again, if there is only one profile, we load his racks config
				if (dataProfiles.data.kioskOwnerConfigs.length === 1 && dataProfiles.data.kioskOwnerConfigs[0].selected) {
					const apiCallConfig = R.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE(dataProfiles.data.kioskOwnerConfigs[0].id)
					try {
						const dataConfig = yield API_TOKEN(user.jwt).get(apiCallConfig)

						yield put(initKioskCreationDefinitionActionCreators.getProfileConfigCustomerSuccess(dataConfig.data))
					} catch (e) {
						yield put(errorManagerActionCreators.createError(e.response))

						yield put(initKioskCreationDefinitionActionCreators.getProfileConfigCustomerFailure(e.response))
					}
				}
			} catch (e) {
				yield put(errorManagerActionCreators.createError(e.response))

				yield put(initKioskCreationDefinitionActionCreators.getProfilesByKioskCustomerFailure(e.response))
			}
		}
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getAvailableListsCustomerFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getProfilesByKioskCustomer = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK(payload.idProfile)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getProfilesByKioskCustomerSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getProfilesByKioskCustomerFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getProfileConfigCustomer = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE(payload.idProfile)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getProfileConfigCustomerSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getProfileConfigCustomerFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const saveDefinitionCustomer = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(initKioskCreationDefinitionActionCreators.saveDefinitionCustomerSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__initKiosk_stepOne_success'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.saveDefinitionCustomerFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createDefinitionCustomer = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER()
	const redirectRequest = `${uriList.initKiosks}${uriList.initKioskCustomerManager}`
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(initKioskCreationDefinitionActionCreators.createDefinitionCustomerSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__initKiosk_stepOne_success', redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.createDefinitionCustomerFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getDefinitionCustomer = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_CUSTOMER(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getDefinitionCustomerSuccess(data.data))

		// If profile set, do a direct back call ?
		const f = find(data.data.kioskOwnerConfigs, (o) => o.selected === true)
		if (!isUndefined(f)) {
			const apiCallProfile = R.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE(f.id)
			const dataProfile = yield API_TOKEN(user.jwt).get(apiCallProfile)
			yield put(initKioskCreationDefinitionActionCreators.getProfileConfigCustomerSuccess(dataProfile.data))
		}
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getDefinitionCustomerFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getAvailableListsBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getAvailableListsBusinessSuccess(data.data))
		// Checking if there is only one kiosk model
		// In this case, we trigger the call to get profiles
		if (data.data.kioskModels.length === 1 && data.data.kioskModels[0].selected) {
			const apiCallProfiles = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK(data.data.kioskModels[0].id)
			try {
				const dataProfiles = yield API_TOKEN(user.jwt).get(apiCallProfiles)

				yield put(initKioskCreationDefinitionActionCreators.getProfilesByKioskBusinessSuccess(dataProfiles.data))

				// And again, if there is only one profile, we load his racks config
				if (dataProfiles.data.kioskOwnerConfigs.length === 1 && dataProfiles.data.kioskOwnerConfigs[0].selected) {
					const apiCallConfig = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE(dataProfiles.data.kioskOwnerConfigs[0].id)
					try {
						const dataConfig = yield API_TOKEN(user.jwt).get(apiCallConfig)

						yield put(initKioskCreationDefinitionActionCreators.getProfileConfigBusinessSuccess(dataConfig.data))
					} catch (e) {
						yield put(errorManagerActionCreators.createError(e.response))

						yield put(initKioskCreationDefinitionActionCreators.getProfileConfigBusinessFailure(e.response))
					}
				}
			} catch (e) {
				yield put(errorManagerActionCreators.createError(e.response))

				yield put(initKioskCreationDefinitionActionCreators.getProfilesByKioskBusinessFailure(e.response))
			}
		}
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getAvailableListsBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getProfilesConfigBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES(payload.idProfile)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getProfilesConfigBusinessSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getProfilesConfigBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const saveDefinitionBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.SAVE_KIOSK_CREATION_DEFINITION_BUSINESS()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(initKioskCreationDefinitionActionCreators.saveDefinitionBusinessSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__initKiosk_stepOne_success'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.saveDefinitionBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createDefinitionBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_KIOSK_CREATION_DEFINITION_BUSINESS()
	const redirectRequest = `${uriList.initKiosks}${uriList.initKioskBusinessManager}`
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(initKioskCreationDefinitionActionCreators.createDefinitionBusinessSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__initKiosk_stepOne_success', redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.createDefinitionBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getDefinitionBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getDefinitionBusinessSuccess(data.data))

		// If profile set, do a direct back call ?
		const f = find(data.data.kioskOwnerConfigs, (o) => o.selected === true)
		if (!isUndefined(f)) {
			const apiCallProfile = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE(f.id)
			const dataProfile = yield API_TOKEN(user.jwt).get(apiCallProfile)
			yield put(initKioskCreationDefinitionActionCreators.getProfileConfigBusinessSuccess(dataProfile.data))
		}
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getDefinitionBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getProfilesByKioskBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK(payload.idKioskModel)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getProfilesByKioskBusinessSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getProfilesByKioskBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getProfileConfigBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE(payload.idProfile)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.getProfileConfigBusinessSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.getProfileConfigBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const refreshDefinitionBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationDefinitionActionCreators.refreshDefinitionBusinessSuccess(data.data))

		// If profile set, do a direct back call ?
		const f = find(data.data.kioskOwnerConfigs, (o) => o.selected === true)
		if (!isUndefined(f)) {
			const apiCallProfile = R.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE(f.id)
			const dataProfile = yield API_TOKEN(user.jwt).get(apiCallProfile)
			yield put(initKioskCreationDefinitionActionCreators.getProfileConfigBusinessSuccess(dataProfile.data))
		}
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationDefinitionActionCreators.refreshDefinitionBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS, getAvailableListsCustomer)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK, getProfilesByKioskCustomer)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE, getProfileConfigCustomer)
	yield takeLatest(ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER, saveDefinitionCustomer)
	yield takeLatest(ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER, createDefinitionCustomer)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER, getDefinitionCustomer)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS, getAvailableListsBusiness)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK, getProfilesByKioskBusiness)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES, getProfilesConfigBusiness)
	yield takeLatest(ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_BUSINESS, saveDefinitionBusiness)
	yield takeLatest(ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_BUSINESS, createDefinitionBusiness)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS, getDefinitionBusiness)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE, getProfileConfigBusiness)
	yield takeLatest(ActionsTypes.REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS, refreshDefinitionBusiness)
}

export default sagas
